import React from 'react';
import './OurStory.css';
import { Helmet } from 'react-helmet';

const OurStory = () => {
    return (
        <div className="our-story-container">
            <Helmet>
  <title>Our Story | Verdure</title>
  <meta name="description" content="Meet the students behind Verdure and learn how we’re redefining conscious shopping for a new generation." />
  <meta property="og:title" content="Our Story | Verdure" />
  <meta property="og:description" content="Why we created Verdure: a student-founded platform to support indie sustainable businesses." />
</Helmet>

            <div className="our-story-content">

                <div className="hero-section">
                    <h1>About Us</h1>
                    <div className="leaf-decoration"></div>
                </div>

                {/* About Us Section */}
                <section id="about" className="about-section">
                    <div className="container">

                        <div className="section-heading">

                        </div>
                        {/* <div className="about-content">
        <br></br>
      <p>
        Verdure is a digital marketplace built to highlight small, indie and sustainable businesses you may have never heard of. We want to make sustainable shopping more accessible, relatable, and transparent. If you've ever wanted to shop more eco-friendly but felt overwhelmed by the options—or found them too expensive or hard to connect with—we’re here to change that.
      </p>
      <p>
        We curate ethical and sustainable brands on one convenient platform, especially for people starting their environmental journey. From clothing and cosmetics to home goods and learning resources, every item is chosen with care to meet real lifestyle needs without compromising on quality or style.
      </p>
      <p>
        Our goal is to support ethical businesses and make sustainability feel less intimidating and more approachable for younger audiences who want to shop in line with their values.
      </p>
      <p>
        Every brand featured on Verdure is vetted by our team and sustainability-focused student organizations for ethical practices, transparent sourcing, and real impact. You’ll find clear details on each business page—so you can shop with confidence and purpose.
      </p>
    </div> */}

                        <div className="about-content">
                            <br />
                            <p>
                                Verdure is a student-founded marketplace uncovering the next generation of standout brands — small, independent businesses that lead with sustainability, transparency, and soul. Every brand featured on Verdure is guaranteed sustainable and ethically run, personally vetted by our team and partners for real impact (no greenwashing here).
                            </p>
                            <p>
                                Our platform was created to make sustainable shopping feel exciting, accessible, and deeply human. Whether you're just beginning your eco-conscious journey or looking for your next favorite indie brand, Verdure helps you discover products that align with your values — all while uplifting the businesses behind them.
                            </p>
                            <p>
                                From fashion and skincare to home goods and creative tools, we spotlight mission-driven creators whose products are as intentional as they are beautiful. Nearly all profits go directly back to the brands, helping them grow and reach more like-minded customers.
                            </p>
                            <p>
                                We’re here to simplify the conscious shopping experience — so you don’t have to dig through endless options to find what’s truly sustainable. Just real brands, real stories, and real purpose.
                            </p>
                        </div>

                    </div>
                </section>

                <div className="hero-section">
                    <h1>Our Story</h1>
                    <div className="leaf-decoration"></div>
                </div>



                <div className="story-text">
                    <p>
                        Verdure was founded by three University of Washington students passionate about making a difference in environmentalism and technology.
                    </p>

                    <p>
                        As environmentalists ourselves, we noticed how challenging it was to find platforms that aligned with our values—ones that were relatable, offered affordable options, and provided convenience. It was particularly difficult to distinguish between companies engaged in greenwashing and those with genuine transparency.
                    </p>

                    <p>
                        Finding trustworthy products required browsing multiple sites, and there was no single destination for sustainable products relevant to younger people and individuals from all backgrounds. Due to this inconvenience, we often defaulted to larger marketplaces but struggled to find the ethically-made products we desired.
                    </p>

                    <div className="highlight-box">
                        <p>
                            That's why we created Verdure—a platform emphasizing transparency while providing accessible, environmentally-friendly products that resonate with our generation.
                        </p>
                    </div>

                    <p>
                        Our marketplace offers items across a range of price points, making it easy for users to filter according to their needs and budget.
                    </p>

                    <p className="closing-paragraph">
                        As students, we're deeply grateful for your support. Our dream is to uplift sustainable businesses and demonstrate that eco-conscious shopping can be the norm—proving there's a way to shop conveniently online without compromising your values or your wallet.
                    </p>
                </div>

                <div className="founders-section">
                    <h2>Founded with Purpose</h2>
                    <div className="values-grid">
                        <div className="value-card">
                            <div className="icon eco"></div>
                            <h3>Eco-Conscious</h3>
                            <p>Committed to environmental sustainability in everything we do</p>
                        </div>
                        <div className="value-card">
                            <div className="icon transparent"></div>
                            <h3>Transparent</h3>
                            <p>Clear information about product origins and environmental impact</p>
                        </div>
                        <div className="value-card">
                            <div className="icon accessible"></div>
                            <h3>Accessible</h3>
                            <p>Making sustainable shopping affordable for all budgets</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurStory;